import {getData} from "../api/get-data";

export const getItemsCount = ({filter, resolveHandler}) => {
  getData({
    [`get_items`]: {
      [`data`]: `count`,
      [`filter`]: filter,
    }
  })
  .then((response) => {
    resolveHandler(response);
  });
};
